//built-in libraries
import { useState } from 'react';

// custom components
import SingleUserInviteForm from './SingleUserInviteForm';
import MultipleUserInviteForm from './MultipleUserInviteForm';

//Third party libraries
import { UserIcon, DocumentTextIcon } from '@heroicons/react/solid';

//Assets and Miscellaneous

//Component Begin
export default function NewUserForm({
  formModalHandler,
}: {
  formModalHandler: (modalName: string) => void;
}) {
  const [tabIndex, setTabIndex] = useState<number>(0);

  return (
    <>
      <h2 className='mt-0'>Invite New User</h2>
      <div className='flex gap-4 border-b-2'>
        <div
          onClick={() => setTabIndex(0)}
          className={`flex gap-2 py-4 cursor-pointer ${
            tabIndex === 0
              ? 'text-primaryColor-normal'
              : 'text-neutralColor-normal'
          } hover:border-primaryColor-normal group`}
        >
          <UserIcon className='w-5 h-5 group-hover:text-primaryColor-normal' />
          <span className='group-hover:text-primaryColor-normal'>
            Invite a User
          </span>
        </div>
        <div
          onClick={() => setTabIndex(1)}
          className={`flex gap-2 py-4 cursor-pointer ${
            tabIndex === 1
              ? 'text-primaryColor-normal'
              : 'text-neutralColor-normal'
          }  hover:border-primaryColor-normal group`}
        >
          <DocumentTextIcon className='w-5 h-5 group-hover:text-primaryColor-normal' />
          <span className='group-hover:text-primaryColor-normal'>
            Bulk Invite
          </span>
        </div>
      </div>
      {tabIndex === 0 && (
        <SingleUserInviteForm formModalHandler={formModalHandler} />
      )}
      {tabIndex === 1 && (
        <MultipleUserInviteForm formModalHandler={formModalHandler} />
      )}
    </>
  );
}
